@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-parameters-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [params]="_context.formContext.item"
                (paramsUpdated)="onParamsUpdated($event)"
                (canceled)="onCanceled($event)"></app-parameters-form>
        </mat-tab>
    </mat-tab-group>
}
